import React from "react";
import Request from "../../Request";
import moment from "moment";
import {connect} from "react-redux";
import {NotificationManager} from "react-notifications";
import "../../less/stylesheet/form-input.css";
import '../../containers/Home/style.css'
import '../../less/locationPicker.css'

import {Helmet} from "react-helmet";
import loadable from '@loadable/component'


const TimePickerBox = loadable(() => import('../timePickerBox'))


const $ = window.$;


class LaundryTimerPicker extends React.Component {
    syncSelectedTime = () => {
        let {pickupTime, deliveryTime} = this.props;
        if ((pickupTime && pickupTime.date) || (deliveryTime && deliveryTime.date)) {
            this.callBackTimeSlot({
                pickupDate: pickupTime && pickupTime.date ? pickupTime.date : '',
                pickupTime: pickupTime && pickupTime.startTime ? pickupTime : '',
                deliveryDate: deliveryTime && deliveryTime.date ? deliveryTime.date : '',
                deliveryTime: deliveryTime && deliveryTime.startTime ? deliveryTime : ''
            })
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            showSearchBox: false,
            locationArray: [],
            selectedAddress: {},
            selectedAddressLabel: '',
            visibleTimerBlock: false,
            pickupViewTime: '',
            deliveryViewTime: '',
            timeDefaultObj: {},
            singleSlot: {},
            selectedBlock: 0,
            hashTag: window.location.search,
            isDisabled: false,
            errorMessage: ""

        }

    }

    componentDidMount() {

        $(document).ready(function () {
            var some_id = $('#searchBox');
            some_id.prop('type', 'text');
            some_id.removeAttr('autocomplete');
        });
        this.syncSelectedTime()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pickupTime !== this.props.pickupTime || prevProps.deliveryTime !== this.props.deliveryTime) {
            this.syncSelectedTime()
        }
    }


    _showTimer(index) {
        let {selectedAddress, singleSlot} = this.props;
        if (selectedAddress && selectedAddress.viewAddress) {
            if (singleSlot && singleSlot._id) {
                this.setState({visibleTimerBlock: true, selectedBlock: index})
            } else {
                alert('1stopwash does not currently serve your area.\n' +
                    'We\'re always adding new locations so check back soon.');
            }
        } else {
            alert('Enter your postcode & select a address first.');
            document.getElementById("searchBox").focus();
        }

    }

    _hideTimer = () => {
        this.setState({visibleTimerBlock: false})
    }

    _placeOrder = async (item) => {
        let {selectedAddress, singleSlot} = this.props;
        this._hideTimer();
        if (!item.pickupDate) {
            return NotificationManager.warning('Please Choose Pickup Date & Time');
        }
        if (!item.deliveryDate) {
            return NotificationManager.warning('Please Choose Delivery Date & Time');
        }
        let data = {
            slotId: singleSlot._id,
            address: selectedAddress,
            pickupTime: {date: item.pickupDate, ...item.pickupTime},
            deliveryTime: {date: item.deliveryDate, ...item.deliveryTime}
        }

        this.props._placeOrderCallback(data)
    }

    callBackTimeSlot = (obj) => {
        let pickupViewTime = '';
        let deliveryViewTime = '';
        if (obj.pickupDate) {
            pickupViewTime += moment(obj.pickupDate).format('DD-MMM-YYYY');
        }
        if (obj.pickupTime && obj.pickupTime.startTime && obj.pickupTime.endTime) {
            pickupViewTime += `, ${obj.pickupTime.startTime}:00 - ${obj.pickupTime.endTime}:00`;
        }
        if (obj.deliveryDate) {
            deliveryViewTime += moment(obj.deliveryDate).format('DD-MMM-YYYY');
        }
        if (obj.deliveryTime && obj.deliveryTime.startTime && obj.deliveryTime.endTime) {
            deliveryViewTime += `, ${obj.deliveryTime.startTime}:00 - ${obj.deliveryTime.endTime}:00`;
        }
        this.setState({pickupViewTime, deliveryViewTime, timeDefaultObj: obj})
    }

    render() {

        let {
            visibleTimerBlock,
            pickupViewTime, deliveryViewTime, timeDefaultObj, selectedBlock
        } = this.state;
        let {singleSlot} = this.props;
        return (
            <React.Fragment>
                <Helmet>
                    <link rel="preload" href="/assets/fonts/truck.woff?akwne7" as="font" type="font/woff" crossOrigin/>
                    <link rel="preload" href="/assets/css/fontCss.css" as="style" onLoad="this.rel='stylesheet'"/>
                </Helmet>
                <div className="row" style={{position: 'relative'}}>
                    <div className="col-md-6 col-sm-12 related-form">
                        <div className="related-form">
                            <div
                                className={`pic-date form-control ${pickupViewTime ? 'timePickerCls' : ''}`}
                                onClick={() => this._showTimer(0)}>
                                {pickupViewTime ? <div>
                                    <div className={'dateF'}>Pickup Time</div>
                                    <div className={'timeF'}>{pickupViewTime}</div>

                                </div> : 'Pickup Date & Time'}
                                <span className="icon-truck-right"></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 related-form dd">
                        <div className="related-form">
                            <div
                                className={`pic-date form-control ${deliveryViewTime ? 'timePickerCls' : ''}`}
                                onClick={() => this._showTimer(1)}>
                                {deliveryViewTime ? <div>
                                    <div className={'dateF'}>Delivery Time</div>
                                    <div className={'timeF'}>{deliveryViewTime}</div>
                                </div> : 'Delivery Date & Time'}

                                <span className="icon-truck-left"></span>
                            </div>
                        </div>
                    </div>
                    {visibleTimerBlock && singleSlot && singleSlot._id ?
                        <TimePickerBox hideTimer={this._hideTimer} _placeOrder={this._placeOrder}
                                       singleSlot={singleSlot}
                                       defaultTimeSlot={timeDefaultObj}
                                       confirmBtnText={'Next'}
                                       selectedBlock={selectedBlock}
                                       visibleTimerBlock={visibleTimerBlock}
                                       callBackTimeSlot={this.callBackTimeSlot}/> : ''}


                </div>

                <div className="place-order btn_group">
                    {this.props.goBackFxn ?
                        <button className="btn btn-back"
                                onClick={() => {
                                    this.props.goBackFxn();
                                }}>
                            <img src="/assets/img/arrow-left.png"/>&nbsp;Back
                        </button> : null}
                    <button className="btn btn-my" type="button" id={"schedulePickUp"}
                            onClick={() => this._placeOrder(timeDefaultObj)}>
                        Next &nbsp;<img src="/assets/img/arrow-right.png"/>
                    </button>
                </div>
            </React.Fragment>
        )
    }
}


const mapStateToProps = ({global, router}) => {

}
const mapDispatchToProps = (dispatch) => {
    return {
        showLoader: () => dispatch({type: 'SHOW_LOADER'}),
        hideLoader: () => dispatch({type: 'HIDE_LOADER'}),
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LaundryTimerPicker)
